(function() {
  "use strict";

  angular.module("app").directive("cccActionsBar", cccActionsBar);

  function cccActionsBar() {
    return {
      restrict: "EA",
      scope: false,
      controller: "ActionsBarController"
    };
  }
})();
